import styled from 'styled-components';

import {DropdownBoxCoordinator} from '../../../../libs/shared/ui/src/components/boxedInputs/dropdownBoxCoordinator';

export const StyledCalendarDropdownBoxCoordinator = styled(DropdownBoxCoordinator)`
  padding: 0px 0px 5px 0px;
`;
